module.exports = __webpack_public_path__ + "static/media/ninth_newpaper_plant1.cec4e2c4.jpg";